import React, { Component } from 'react';
import Home from './Home';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as agentActions from 'store/modules/agents';

class HomeContainer extends Component {
  componentDidMount() {
    this.props.AgentsActions.getNumAgents();
  }

  render() {
    return <Home {...this.props} />;
  }
}

export default connect(
  ({ agents, pender }) => ({
    section: agents.section,
    sectionType: agents.sectionType,
    division: agents.division,
    kic: agents.kic,
    numAgents: agents.numAgents,
    error: agents.error,
  }),
  dispatch => ({
    AgentsActions: bindActionCreators(agentActions, dispatch),
  })
)(HomeContainer);



// WEBPACK FOOTER //
// ./src/components/Home/HomeContainer.js